export default "__VITE_ASSET__btLZxow_chTA2Vu8CDdmtA__";